<nav class="navbar">
    <div class="navbar-left">
        <slot name="menu"></slot>
    </div>
    <div class="navbar-right">
        <slot name="avatar"></slot>
    </div>
</nav>